<template>
    <page>
        <module enable-flex>
            <m-search @search="search">
                <m-search-item label="标题">
                    <c-input name="title"></c-input>
                </m-search-item>
                <m-search-item label="状态">
                    <c-select name="state" :options="[{name: '启用', value: 1}, {name: '禁用', value: 2}]"></c-select>
                </m-search-item>
            </m-search>

            <m-operate>
                <c-button
                        v-if="auth('b_system_notice_edit')"
                        color="main"
                        prepend-icon="tf-add"
                        @click="editArticle()"
                >
                    新增公告
                </c-button>
                <c-button
                        v-if="auth('b_system_notice_consultation_manage')"
                        @click="openConsultations"
                >
                    栏目管理
                </c-button>
            </m-operate>

            <c-table ref="list" height="grow" :paging="true">
                <c-table-column
                        label="标题"
                        name="title"
                        width="260"
                        fixed="left"
                >
                </c-table-column>

                <c-table-column
                        label="栏目"
                        name="consultation_name"
                        width="120"
                >
                </c-table-column>

                <c-table-column label="是否标新" width="90">
                    <template #default="{data}">{{ Number(data.is_new) === 1 ? '是' : '否' }}</template>
                </c-table-column>

                <c-table-column label="状态" width="90">
                    <template #default="{data}">
                        <c-switch
                                v-if="auth('b_system_notice_state')"
                                v-model="data.state"
                                :state-value="[1, 2]"
                                :state-text="['启用', '禁用']"
                                @beforeChange="changeState(arguments[0], arguments[1], data)"
                        ></c-switch>
                        <c-state
                                v-else
                                dict="disableEnableDic"
                                :value="data.state"
                        ></c-state>
                    </template>
                </c-table-column>

                <c-table-column
                    label="创建时间"
                    name="create_date"
                    width="160"
                >
                </c-table-column>

                <c-table-column
                    label="更新时间"
                    name="update_date"
                    width="160"
                >
                </c-table-column>

                <c-table-column type="button" label="操作" width="160">
                    <template #default="{data}">
                        <c-table-button icon="tf-edit" @click="editArticle(data)">编辑</c-table-button>
                        <c-table-button v-if="auth('b_system_notice_delete')" icon="tf-trash" color="red" @click="remove(data)">删除</c-table-button>
                    </template>
                </c-table-column>
            </c-table>

            <!--公告栏目管理弹窗-->
            <c-dialog ref="consultation" title="公告栏目管理" width="760" height="400" :button="false">
                <div class="consultation-content">
                    <m-operate>
                        <c-button color="main" @click="editConsultation()">新增栏目</c-button>
                    </m-operate>
                    <c-table ref="consultations" :paging="false">
                        <c-table-column label="栏目名称" name="name">
                        </c-table-column>
                        <c-table-column label="状态" name="state">
                            <template #default="{data}">
                                <c-switch
                                        v-model="data.state"
                                        :state-value="[1, 2]"
                                        :state-text="['启用', '禁用']"
                                        @beforeChange="changeConsultationState(arguments[0], arguments[1], data)"
                                ></c-switch>
                            </template>
                        </c-table-column>
                        <c-table-column type="button" label="操作">
                            <template #default="{data}">
                                <c-table-button icon="tf-edit" @click="editConsultation(data)">编辑</c-table-button>
                                <c-table-button icon="tf-trash" color="red" @click="deleteConsultation(data)">删除</c-table-button>
                            </template>
                        </c-table-column>
                    </c-table>
                </div>
            </c-dialog>

            <!--新增/编辑栏目弹窗-->
            <c-dialog
                    ref="consultationEdit"
                    :title="consultationData.id ? '编辑栏目' : '新增栏目'"
                    @resolve="saveConsultation"
            >
                <c-form ref="consultationForm" unit-width="100%">
                    <c-form-item label="栏目名称" required>
                        <c-input v-model="consultationData.name"></c-input>
                    </c-form-item>
                </c-form>
            </c-dialog>
        </module>
    </page>
</template>

<script>
export default {
    data() {
        return {consultationData: {}};
    },

    mounted() {
        this.search({});
    },

    methods: {
        editArticle(data) {
            this.globalDialog('systemArticleEdit', {
                props: {type: 'notice', id: data ? data.id : ''},
            }, () => this.$refs.list.update());
        },

        search(data) {
            this.$refs.list.load({
                url: '/article/list',
                data: Object.assign({}, data || {}, {article_type: 1}),
            });
        },

        /******公告启禁用*********/
        changeState(state, next, data) {
            this.request({
                url: '/article/state',
                data: {id: data.id, article_type: 1, state: state ? 2 : 1},
                success: () => this.$refs.list.update(),
            });
        },

        /******栏目启禁用*********/
        changeConsultationState(state, next, data) {
            this.request({
                url: '/consultation/state',
                data: {id: data.id, state: state ? 2 : 1},
                success: () => this.$refs.consultations.update(),
            });
        },

        /******删除公告*********/
        remove(data) {
            this.$confirm({
                message: `确认删除【${data.title}】？`,
                cancelButton: true,
                resolve: () =>
                    this.request({
                        url: '/article/delete',
                        data: {id: data.id, article_type: 1},
                        success: () => this.$refs.list.update(),
                    }),
            });
        },

        /******打开栏目管理弹窗*********/
        openConsultations() {
            this.$refs.consultation.open();
            this.$refs.consultations.load({url: '/consultation/list', data: {}});
        },

        /******编辑栏目*********/
        editConsultation(data) {
            this.consultationData = Object.assign({}, data || {});
            this.$refs.consultationEdit.open();
        },

        /******保存栏目*********/
        saveConsultation(stop) {
            stop();
            if (!this.consultationData.name) {
                this.$message({message: '请输入栏目名称', type: 'error'});
                return;
            }
            this.request({
                url: '/consultation/edit',
                data: this.consultationData,
                success: () => {
                    this.$refs.consultationEdit.close();
                    this.$refs.consultations.update();
                },
            });
        },

        /******删除栏目*********/
        deleteConsultation(data) {
            this.$confirm({
                message: `确认删除【${data.name}】？`,
                cancelButton: true,
                resolve: () =>
                    this.request({
                        url: '/consultation/delete',
                        data: {id: data.id},
                        success: () => this.$refs.consultations.update(),
                    }),
            });
        },
    },
};
</script>

<style lang="stylus" scoped>
.consultation-content {
    padding: 0 16px;
}
</style>
